import React from 'react';
import { CFCProps } from 'types';
import { Loading, Button, Link } from 'carbon-components-react';
import { connect, useSelector } from 'react-redux';
import { convertEventStatusTolabel } from 'appConstants/webhook';
import { toLocalDateTimeFormatWithSeconds } from 'utilities/helper.util';
import { selectNotificationHistory } from 'redux/webhook';
import { convertHttpStatusTolabel } from '../../utils/httpStatusCode.util';

const httpStatusOK = [200, 201];

export const DetailsPanel: React.FC<Props> = ({ onClose, handleDownload }) => {
  const notificationHistory: any = useSelector(selectNotificationHistory);
  const notificationDetails: any = notificationHistory?.notificationDetails;
  const loading: boolean = notificationHistory?.notificationDetailsLoading;

  return (
    <div
      id="webhook-history-detail-panel"
      data-testid="webhook-history-detail-panel"
      className="panel--body"
    >
      {loading ? (
        <div className="loader--wrapper">
          <Loading description="Active loading indicator" withOverlay={false} />
        </div>
      ) : (
        <>
          <hr className="section--divider" />
          {notificationDetails && (
            <>
              <h2 className="panel--body-sub-heading">
                Event status:{' '}
                {convertEventStatusTolabel(notificationDetails.status)}
              </h2>
              <section
                id="notificationDetails"
                className="panel--body-sections"
              >
                <div className="panel--body-content">
                  <div>
                    <span className="label label600">SYS-ID:</span>{' '}
                    {notificationDetails.id}
                  </div>
                  {notificationDetails.eventType === 'enquiry:create' && (
                    <div>
                      <span className="label label600">Job:</span>{' '}
                      {notificationDetails.jobNumber}
                    </div>
                  )}
                  {(notificationDetails.eventType === 'referral:create' ||
                    notificationDetails.eventType === 'response:create' ||
                    notificationDetails.eventType === 'referral:update') && (
                    <div>
                      <span className="label label600">Ref:</span>{' '}
                      {notificationDetails.sequenceNumber}
                    </div>
                  )}
                  {(notificationDetails.eventType === 'user:update' ||
                    notificationDetails.eventType === 'user:create') && (
                    <div>
                      <span className="label label600">Email:</span>{' '}
                      {notificationDetails.email}
                    </div>
                  )}
                </div>
                <div className="panel--body-content">
                  <div>
                    <span className="label">Initiated:</span>{' '}
                    {toLocalDateTimeFormatWithSeconds(
                      notificationDetails.initiated
                    )}
                  </div>
                  <div>
                    <span className="label">Successful:</span>{' '}
                    {httpStatusOK.includes(notificationDetails.statusCode)
                      ? toLocalDateTimeFormatWithSeconds(
                          notificationDetails.successful
                        )
                      : 'NA'}
                  </div>
                  <div>
                    <span className="label">HTTP Status code:</span>{' '}
                    {notificationDetails.statusCode}{' '}
                    {convertHttpStatusTolabel(notificationDetails.statusCode)}
                  </div>
                  <div>
                    <span className="label">Processing time:</span>{' '}
                    {notificationDetails.processingTime} ms
                  </div>
                  <div>
                    <span className="label">Failed attempts:</span>{' '}
                    {notificationDetails.failureCount}
                  </div>
                  <div>
                    <span className="label">Next retry:</span>{' '}
                    {notificationDetails.retryScheduledAt
                      ? toLocalDateTimeFormatWithSeconds(
                          notificationDetails.retryScheduledAt
                        )
                      : 'NA'}
                  </div>
                </div>
              </section>
              <hr className="section--divider" />
              <section
                id="subscriptionDetails"
                className="panel--body-sections"
              >
                <div id="url" className="panel--body-content">
                  <div>
                    <span className="label">Web service url</span>
                  </div>
                  <div>{notificationDetails.url}</div>
                </div>
                <div id="secretKey" className="panel--body-content">
                  <div>
                    <span className="label">Signing secret key</span>
                  </div>
                  <div>{notificationDetails.clientKey}</div>
                </div>
                {notificationDetails.customHeaders.length > 0 && (
                  <div id="customHeaders" className="panel--body-content">
                    <div>
                      <span className="label">HTTP headers</span>
                    </div>
                    <div>
                      {notificationDetails.customHeaders.map((header: any) => {
                        return (
                          <>
                            <div>{header.name}</div>
                            <div>{header.value}</div>
                          </>
                        );
                      })}
                    </div>
                  </div>
                )}
              </section>
              <hr className="section--divider" />

              <section className="panel--body-controls">
                <Button
                  kind="tertiary"
                  size="small"
                  onClick={() =>
                    handleDownload(
                      notificationDetails.messagePayload,
                      notificationDetails.id
                    )
                  }
                >
                  Download payload JSON
                </Button>
                <Link onClick={() => onClose()}>Close</Link>
              </section>
            </>
          )}
        </>
      )}
    </div>
  );
};

const connector = connect();

type OwnProps = {
  onClose: Function;
  handleDownload: Function;
};

type Props = CFCProps<typeof connector> & OwnProps;

export default React.memo(connector(DetailsPanel));
